import { Button, Heading, Modal, Progress, Text } from 'rsuite'
import loading_placeholder from '../../../assets/loading_placeholder_2.jpeg'

const ModelLoadingModal = ({
  open,
  progress,
  handleClose,
  isPolling = false,
  solutionName = '',
}) => {
  const isOptimize = solutionName === 'OPTIMIZE'

  const getHeading = () => {
    if (isOptimize && isPolling) {
      return 'Processing your Optimize model...'
    }
    return "Hang on! Predict's powerful machine learning model is hard at work."
  }

  const getDescription = () => {
    if (isOptimize && isPolling) {
      return "The Optimize model uses Meridian MMM optimization, which takes 10-20 minutes to complete. We're checking the status every 10 seconds."
    }
    if (isOptimize) {
      return 'The Optimize model is being submitted for processing. This uses advanced optimization algorithms to find the best budget allocation across your marketing channels.'
    }
    return 'Think of the Impact gradient boosting model as a team of decision-making experts (called trees). Each one looks at your data and tries to guess the outcome, like sales or traffic. The first tree makes a guess, and the next one learns from its mistakes to make improvements to the prediction. Each new tree corrects the errors of the previous ones. In the end, all trees combine efforts to give one strong, accurate prediction. Impact is fast, efficient, and excels at finding patterns in complex, messy real-world data.'
  }

  return (
    <Modal
      backdrop="static"
      size="xs"
      keyboard={false}
      open={open}
      onClose={handleClose}
    >
      <Modal.Body style={{ textAlign: 'center' }}>
        <div style={{ marginBottom: '20px' }}>
          <img
            src={loading_placeholder}
            alt="loading placeholder"
            width={300}
          />
        </div>
        <Heading>{getHeading()}</Heading>
        <Text style={{ textAlign: 'justify', margin: '10px' }}>
          {getDescription()}
        </Text>
        <Progress.Line percent={progress} status="active" showInfo={false} />
      </Modal.Body>
      <Modal.Footer style={{ textAlign: 'center' }}>
        <Button onClick={handleClose} appearance="ghost">
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ModelLoadingModal
